import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserModel} from '../../../../shared/services/user/user.model';
import {Select} from '@ngxs/store';
import {AppState} from '../../../../state/appState';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-overview-user-table',
  templateUrl: './overview-user-table.component.html',
  styleUrls: ['./overview-user-table.component.scss']
})
export class OverviewUserTableComponent {
  @Input() users: UserModel[];

  @Output() deleteUser = new EventEmitter<string>();
  @Output() editUser = new EventEmitter<UserModel>();

  @Select(AppState.currentUser$) currentUser$: Observable<UserModel>;

  constructor() {
  }

  onDeleteUser(userName: string) {
    this.deleteUser.emit(userName);
  }

  onEditUser(user: UserModel) {
    this.editUser.emit(user);
  }
}
